import { FC } from 'react';
import { Box, StackProps, Text, TextProps } from '@chakra-ui/react';
import { DataTestId } from 'types/general.types';

interface ChakraPageTitleProps extends StackProps {
  titleTextProps?: TextProps & DataTestId;
}

export const ChakraPageTitle: FC<ChakraPageTitleProps> = ({
  children,
  titleTextProps,
  ...rest
}) => (
  <Box width="full" {...rest}>
    <Text
      as="h1"
      data-testid="page-title"
      fontSize="lg"
      fontWeight={500}
      color="M.70"
      lineHeight="normal"
      {...titleTextProps}
    >
      {children}
    </Text>
  </Box>
);
